import { DatasourcesContextProvider, IDatasource, Schema } from "@generation/core";
import { ReadContainer } from "@generation/overview";
import * as React from "react";
import { translate } from "../Locales/translator";
import { Spinner } from "@shared/common";

export interface IReadOnlyFormProps {
  introText?: string | React.ReactNode;
  outroText?: string | React.ReactNode;
  values: any;
  getSchema: () => Schema;
  handleSubmit: (values: any, event: any) => void;
  datasources?: IDatasource[];
  handlePrevious: (values: any, event: any) => void;
  hasGotoPreviousButton?: boolean;
  hasSubmitButton?: boolean;
  stepName: string;
  customClass?: string;
  volgendeButtonLabel?: string;
  isSubmitting?: boolean;
}

export const ReadOnlyForm = (props: IReadOnlyFormProps) => {
  const volgendeBtnLabel = props.volgendeButtonLabel ?? translate("Volgende");
  return (
    <div className={`read-only-form ${props.stepName} ${props.customClass || ""}`}>
      {props.introText && <div className={`intro-text ${props.stepName}`}>{props.introText}</div>}
      <DatasourcesContextProvider datasources={props.datasources || []}>
        <ReadContainer
          schema={props.getSchema()}
          values={props.values}
          uiDefaults={{
            flexDirectionFormGroupControl: "row",
            hideHeaderText: false,
            headerCssClassName: "read-only-form__category-heading",
            formGroupfullWidth: true
          }}
          fieldDefaults={{
            select: {
              usesDatasourcesOrOptionsInOverview: true
            }
          }}
          datasources={props.datasources}
        ></ReadContainer>
      </DatasourcesContextProvider>
      {(props.hasSubmitButton || props.hasGotoPreviousButton) && (
        <div className="formbutton-container">
          {props.hasGotoPreviousButton && (
            <button
              className="btn btn--secondary"
              id="vorigeButton"
              type="button"
              onClick={(event) => {
                event.preventDefault();
                props.handlePrevious(props.values, event);
                return false;
              }}
            >
              {translate("Vorige")}
            </button>
          )}
          {props.hasSubmitButton && (
            <button
              className={`btn btn--primary ${props.isSubmitting ? "btn--is-submitting" : ""}`}
              id="volgendeButton"
              type="submit"
              disabled={props.isSubmitting}
              onClick={(event) => {
                event.preventDefault();
                props.handleSubmit(props.values, event);
                return false;
              }}
            >
              {props.isSubmitting ? <Spinner loading={true} /> : null}
              <span className={props.isSubmitting ? "invisible" : ""}>{volgendeBtnLabel}</span>
            </button>
          )}
        </div>
      )}
      {props.outroText && <div className="outroContainer">{<p>{props.outroText}</p>}</div>}
    </div>
  );
};
